<template>
  <div>
    <div class="nav_warp difcac" :style="{'background': backColor}">
      <div class="nav_cont difb alc">
        <div class="title" :style="{'color': titleColor}">欢迎进入教育考试报名系统</div>
        <!--未登录-->
        <div class="dif alc login" v-if="notLogin">
          <div class="tlt" @click="showLogin=true;isLogin=1">登录</div>
          <div class="trt" @click="showLogin=true;isLogin=2">注册</div>
        </div>
        <!--已登录-->
        <div class="dif alc pointer" v-if="!notLogin">
          <div class="col101010" style="font-size: 1.4rem;margin-right: 2rem;" v-if="$store.state.userinfo.name!==''">欢迎你,{{$store.state.userinfo.name}} <span style="font-size: 1.2rem;color: #333333" @click="logout()">退出登录</span></div>
          <div class="col101010" style="font-size: 1.4rem;margin-right: 2rem;" v-else>欢迎你,{{$store.state.userinfo.phone}} <span style="font-size: 1.2rem;color: #333333" @click="logout()">退出登录</span></div>
          <img class="bra bgcb" style="width: 4rem;height: 4rem;" @click="goUserCenter()" v-if="userInfo.image!==''" :src="userInfo.image">
          <img class="bra bgcb" style="width: 4rem;height: 4rem;" @click="goUserCenter()" v-else src="@/assets/images/icon_avatar.png">
        </div>
      </div>
    </div>
    <!--登录界面-->
    <div class="mengban" v-if="!$store.state.isLogin && showLogin">
      <div class="login_warp">
        <!--关闭-->
        <div class="close" @click="showLogin=false">
          <i class="el-icon-close"></i>
        </div>
        <!--登录-->
        <div v-show="isLogin===1">
          <!--登录标题-->
          <div class="tct col333 title2" style="font-size: 2.2em;font-weight:bold;">登录</div>
          <!--账号-->
          <div class="input dif alc" style="margin-top: 3.2rem;margin-bottom: 4rem;">
            <i class="el-icon-user" style="color: #4eac4e;font-size: 2.6rem;margin-right: 1.5rem;"></i>
            <input type="text" class="inpu_cont" v-model="loginForm.tel" placeholder="请输入手机号">
          </div>
          <!--密码-->
          <div class="input dif alc">
            <i class="el-icon-lock" style="color: #4eac4e;font-size: 2.6rem;margin-right: 1.5rem;"></i>
            <input type="text" class="inpu_cont" v-model="loginForm.password" placeholder="请输入密码">
          </div>
          <!--注册 忘记密码-->
          <div class="difb alc box" style="padding: 0 0.5rem;">
            <div class="pointer text_button" @click="isLogin=2">注册新用户</div>
            <div class="pointer text_button">忘记密码</div>
          </div>
          <!--立即登录-->
          <div class="button difcac colfff pointer" @click="login()">立即登录</div>
        </div>
        <!--注册-->
        <div v-show="isLogin===2">
          <!--登录标题-->
          <div class="tct col333 title2" style="font-size: 2.2em;font-weight:bold;">注册</div>
          <!--账号-->
          <div class="input dif alc" style="margin-top: 3.2rem;">
            <i class="el-icon-user" style="color: #4eac4e;font-size: 2.6rem;margin-right: 1.5rem;"></i>
            <input type="text" class="inpu_cont" v-model="reigster.tel" placeholder="请输入手机号">
          </div>
          <!--密码-->
          <div class="input dif alc" style="margin: 1.8em 0;">
            <i class="el-icon-unlock" style="color: #4eac4e;font-size: 2.6rem;margin-right: 1.5rem;"></i>
            <input type="text" class="inpu_cont" v-model="reigster.password" placeholder="请输入密码">
          </div>
          <!--确认-->
          <div class="input dif alc">
            <i class="el-icon-lock" style="color: #4eac4e;font-size: 2.6rem;margin-right: 1.5rem;"></i>
            <input type="text" class="inpu_cont" v-model="reigster.password2" placeholder="请确认密码">
          </div>
          <!--立即登录-->
          <div class="button difcac colfff pointer  " @click="goRegister()">立即注册</div>
          <!--已有账号-->
          <div class="tct col101010" style="font-size: 1.4rem;margin-top: 2rem;">已有账号，<span style="color: #0bb538" class="pointer" @click="isLogin=1">立即登录</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navBar",
  props: {
    backColor: {
      type: String,
      default: '#fff'
    },
    titleColor: {
      type: String,
      default: '#FFA940'
    }
  },
  data() {
    return {
      acc: '',//账号
      password: '',//密码
      isLogin: 1,//1登录 2注册 3忘记密码
      showLogin: false,
      notLogin: true,
      reigster: { //注册用账号密码
        tel: '',
        password: '',
        password2: '',
      },
      loginForm: { //登录用账号密码
        tel: '',
        password: '',
      },
      userInfo: {
        id: '',
        image: '',
        name: '',
        phone: '',
        sex: '',
      },//用户信息
    }
  },
  methods: {
    logout() {
      this.$confirm('确认要退出当前账号吗？',{type: 'error'})
      .then(res => {
        localStorage.removeItem('jiaoyu')
        this.$store.commit('logout')
        if(this.$route.path==='/') {
          this.$router.go(0)
        }else {
          this.$router.push('/')

        }
      })
    },
    showRegister() {
      this.showLogin=true;
      this.isLogin=2
    },
    goRegister() { //立即注册
      if(this.reigster.tel==='') {
        this.$alert('请输入手机号')
        return
      }else if(!this.$all.isPhone(this.reigster.tel)){
        this.$alert('手机号格式不正确')
        return
      }else if(this.reigster.password==='') {
        this.$alert('请输入密码')
        return
      }else if(this.reigster.password!==this.reigster.password2) {
        this.$alert('两次输入密码不一致')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = {
        tel: this.reigster.tel,
        password: this.reigster.password
      }
      let pid = localStorage.getItem('jiaoyupid')
      if(pid) data.pid = pid
      this.$axios("POST","/login/reg",data).then(res => {
        loading.close();
        if(res.code===1) {
          this.$alert('注册成功', '提示', {
            confirmButtonText: '确定'
          }).then(six => {
            this.isLogin = 1
          })
        }else {
          this.$alert(res.msg)
        }
      })
    },
    goUserCenter() { //跳转到个人中心
      this.$router.push('/user').catch(err => err)
    },
    async login() { //登录
      if(this.loginForm.tel==='') {
        this.$alert('请输入手机号')
        return
      }else if(!this.$all.isPhone(this.loginForm.tel)){
        this.$alert('手机号格式不正确')
        return
      }else if(this.loginForm.password==='') {
        this.$alert('请输入密码')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '登录中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$axios("POST","/login/index",{
        tel: this.loginForm.tel,
        password: this.loginForm.password
      }).then(res => {
        loading.close();
        if(res.code===1) {
          this.$alert('登录成功', '提示', {
            confirmButtonText: '确定'
          }).then(six => {
            this.isLogin = 1
            this.notLogin = false
            this.userInfo = res.data
            this.$store.commit('login',res.data)
          })
        }else {
          this.$alert(res.msg)
        }
      })
      // this.$router.push('/user').catch(err => err) //个人中心
    },
  },
  created() {
    //判断是否登录
    let info = localStorage.getItem('jiaoyu')
    let token = JSON.parse(localStorage.getItem('jiaoyu'))
    if(token && token.id) {
      this.notLogin = false
      this.userInfo = token
      this.$store.commit('login',token)
    }
  }
}
</script>

<style scoped>
  .nav_warp{
    width: 100%;
    height: 4.8rem;
    background: #FFFFFF;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
  }
  .nav_cont{
    height: 100%;
    width: 80%;
  }
  .title{
    font-size: 1.7rem;
    color: #FFA940;
  }
  .login div{
    font-size: 1.8rem;
    width: 7rem;
    cursor: pointer;
  }
  .login div:nth-child(1) {
    border-right: 1px solid #101010;
  }
  .mengban{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 999;
  }
  .login_warp{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 48rem;
    /*height: 46.8rem;*/
    background: #FFFFFF;
    border-radius: 2rem;
    box-sizing: border-box;
    padding: 3em;
  }
  .title2{
    padding-bottom: 2.3rem;
    border-bottom: 1px solid #f2f2f2;
  }
  .input{
    width: 100%;
    height: 5rem;
    border-radius: 0.5rem;
    border: 1px solid #f2f2f2;
    box-sizing: border-box;
    padding: 0 1.4rem;
  }
  .inpu_cont{
    font-size: 1.4rem;
    color: #797979;
    width: 32rem;
  }
  .text_button{
    color: #101010;
    font-size: 1.4rem;
    margin-top: 2.7rem;
  }
  .button{
    width: 34rem;
    height: 5rem;
    border-radius: 0.4rem;
    background-color: #4eac4e;
    color: rgba(255, 255, 255, 1);
    font-size: 1.4rem;
    text-align: center;
    margin: 0 auto;
    margin-top: 5.3rem;
  }
  .close{
    color: #000000;
    font-size: 2.6rem;
    position: absolute;
    top: 3rem;
    right: 3rem;
    cursor: pointer;
  }
  @media (max-width: 560px) {
    .nav_cont{
      width: 90%;
    }
  }
</style>